import url from "../config/axios";

/**
 * Upload one or more files (images or videos) to the server.
 *
 * @param {File[]} data        - Array of File objects to upload
 * @param {Function} onProgress - Optional callback: (percent: number) => void
 * @returns {Promise<string[]>}  Array of server file paths (e.g. ["/images/abc.jpg"])
 *                               Returns [] on error so callers can degrade gracefully.
 */
export const publishImage = async (data, onProgress) => {
  if (!data || data.length === 0) return [];

  const formData = new FormData();
  data.forEach((file) => {
    formData.append("images", file);
  });

  try {
    const res = await url.post("upload/multiple", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percent);
        }
      },
    });

    if (res?.data?.message === "imagesSaved") {
      // Return relative paths — callers use getAsset() to build full URLs
      return (res.data.file || []).map((f) => "/images/" + f.filename);
    }

    console.warn("[Upload] Unexpected server response:", res?.data);
    throw new Error(res?.data?.message || "Upload failed — unexpected server response");

  } catch (err) {
    // Extract the most specific error message available
    const serverMessage =
      err?.response?.data?.message ||   // Server JSON error body
      err?.message ||                    // Axios or JS error
      "Upload failed. Please try again.";

    console.error("[Upload] Error:", serverMessage, err);

    // Re-throw so the caller (onDrop handler) can show a FailedNotify toast
    // instead of a blocking alert()
    throw new Error(serverMessage);
  }
};
